export default __webpack_public_path__ + "static/media/actor_image_front.ce2686aa.png";